import { api } from 'utils/apis/api';
import { transformWaitMusicCreate } from './utils/transformArg';
import { transformWaitMusicReadResponse } from './utils/transformResponse';
export const waitMusicApi = api.injectEndpoints({
    endpoints: (builder) => ({
        readWaitMusic: builder.query({
            query: () => ({
                version: 1,
                path: 'wait_music',
            }),
            transformResponse: transformWaitMusicReadResponse,
        }),
        createWaitMusic: builder.mutation({
            query: (body) => ({
                version: 1,
                path: 'wait_music',
                method: 'POST',
                body: transformWaitMusicCreate(body),
            }),
        }),
        deleteWaitMusic: builder.mutation({
            query: ({ id }) => ({
                version: 1,
                path: `wait_music/${id}`,
                method: 'DELETE',
            }),
        }),
        readWaitMusicUsage: builder.query({
            query: ({ id }) => ({
                version: 1,
                path: `wait_music/${id}/usage`,
            }),
        }),
    }),
});
